import * as Yup from 'yup'

import { OPTION_YES } from '../../../../../../constants/forms'
import {
  AUDIENCE,
  AUDIENCE_OPTION
} from '../../../../LineItemForms/LineItemGoogleCreate/LineItemGoogleCreateForm/LineItemGoogleAudienceForm/fields'
import { CPM_BID } from '../../../../LineItemForms/LineItemGoogleCreate/LineItemGoogleCreateForm/LineItemGoogleCreateMainForm/fields'
import { LINE_ITEM } from '../../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'

import { cpmBidValidation } from '../../../../LineItemForms/LineItemGoogleCreate/LineItemGoogleCreateForm/LineItemGoogleCreateMainForm/validation'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../../hooks/formHooks/listItemFormHooks/fields'

export const getInitialValues = isLineItemsExist => ({
  [AUDIENCE]: [],
  [AUDIENCE_OPTION]: OPTION_YES,
  [LIST_ITEM_OPTION]: isLineItemsExist ? OPTION_EXISTING_LIST_ITEM : OPTION_NEW_LIST_ITEM,
  [LINE_ITEM]: '',
  [CPM_BID]: ''
})

export const getValidationSchema = ({ isRightAllocationBudget }) =>
  Yup.object({
    [AUDIENCE]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(AUDIENCE_OPTION, {
          is: OPTION_YES,
          then: () => Yup.array().min(1, 'Please select at least one option')
        })
    }),

    // line item
    [LINE_ITEM]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_EXISTING_LIST_ITEM,
      then: () => Yup.string().required('Please select line item')
    }),

    ...(isRightAllocationBudget && {
      [CPM_BID]: Yup.number().when(LIST_ITEM_OPTION, {
        is: OPTION_NEW_LIST_ITEM,
        then: () => cpmBidValidation
      })
    })
  })
